<template>
    <div class="devices-list__block" v-if="deviceData" @click="openHeatingHistory">
        <device-status :device="deviceData" :showLocation="showLocation"/>
        <v-layout row class="devices-list__block__title">
            <device-title :device="deviceData"></device-title>
            <v-flex class="btn-block" v-if="deviceData.state">
                <div class="d-inline-flex" v-if="!!deviceData.state.heating">
                    <div v-html="require(`!html-loader!@/assets/icons/flame_icon.svg`)" class="size-30"/>
                </div>
                <div class="d-inline-flex" v-else>
                    <div v-html="require(`!html-loader!@/assets/icons/flame_disabled_icon.svg`)" class="size-30"/>
                </div>
                <device-favorite :device="deviceData"></device-favorite>
            </v-flex>
        </v-layout>
        <div class="main-text ma-1" v-if="deviceData.state && deviceData.state.current_value">
            Текущая температура: {{ (deviceData.state.current_value).toFixed(1)}}°C
        </div>
        <div class="main-text mt-3 mx-2" v-if="!deviceData.is_action" @click.stop.prevent>
            <vue-slider
                v-model="deviceData.state.value"
                :data="values"
                :marks="tickLabels"
                :adsorb="true"
                :interval="1"
                :min="16"
                :max="28"
                :height="16"
                :lazy="true"
                :disabled="deviceData.disabled"
                tooltip="none"
                class="vue-custom-slider"
                @change="changeDeviceSlider"
            />
        </div>
        <v-flex d-flex justify-end>
            <div v-if="deviceData.is_action && deviceData.state" class="note-row">
                {{deviceData.state.last_update.slice(0, 16)}}, &nbsp
            </div>
        </v-flex>
    </div>
</template>

<script>
import { LOADING_TIMEOUT } from "@/utils/constants.js";
export default {
    name: "HeatingDevice",
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: { state: null },
            deviceState: false,
            deviceStateOldValue: null,
            tickLabels: ['OFF', 18, 20, 22, 24, 26, 28],
            values: [16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28,],
            loading: false,
            scrollPrev: 0,
            scrollNext: 0,
            scrollTimeout: null,
            disabledTimeout: null,
        };
    },
    created() {
        this.deviceData = this.device;
        this.deviceState = this.deviceData.state.value ? true : false;
        this.deviceStateOldValue = JSON.parse(JSON.stringify(this.deviceData.state));
    },
    beforeDestroy() {
        if (this.disabledTimeout) {
            clearTimeout(this.disabledTimeout);
        }
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
    },
    computed: {
        isScrolled() {
            return this.$store.state.scrolled;
        },
        readonly() {
            return this.scrollPrev == this.scrollNext;
        },
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
                this.loading = false;
                this.deviceState = this.deviceData.state.value ? true : false;
                if (this.disabledTimeout) {
                    clearTimeout(this.disabledTimeout);
                    this.deviceData.disabled = false;
                }
            }
        },
        isScrolled(val) {
            this.scrollNext = val;
            this.checkScroll();
        },
        "deviceData.state": {
            handler: function(val, old) {
                if (val != old && this.deviceData.state.value != this.deviceStateOldValue.value) {
                    this.deviceStateOldValue = old;
                }
            },
            deep: true,
        },
    },
    methods: {
        checkScroll() {
            if (this.scrollPrev != this.scrollNext) {
                if (this.scrollTimeout) {
                    clearTimeout(this.scrollTimeout);
                }
                this.scrollTimeout = setTimeout(() => {
                    this.scrollPrev = this.scrollNext;
                }, 800);
            }
        },
        changeDeviceSwitch() {
            if (!this.deviceData.is_action) {
                if (this.deviceState) {
                    this.deviceData.state.value = 28;
                } else {
                    this.deviceData.state.value = 17;
                }
                this.changeDeviceValue();
            }
        },
        changeDeviceSlider() {
            if (!this.deviceData.is_action) {
                setTimeout(() => {
                    this.changeDeviceValue();
                }, 1000);
            }
        },
        changeDeviceValue() {
            this.loading = true;
            this.deviceData.disabled = true;
            if (this.disabledTimeout) {
                clearTimeout(this.disabledTimeout);
            }
            this.disabledTimeout = setTimeout(() => {
                this.deviceData.disabled = false;
                this.deviceData.state = this.deviceStateOldValue;
            }, LOADING_TIMEOUT);
            this.$http.put('/devices/home/device/' + this.deviceData.uid + '/state', {
                value: this.deviceData.state.value > 17 ? this.deviceData.state.value : null
            })
                .catch((error) => {
                    if (this.disabledTimeout) {
                        clearTimeout(this.disabledTimeout);
                    }
                    this.deviceData.disabled = false;
                    this.deviceData.state = this.deviceStateOldValue;
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        openHeatingHistory() {
            if (this.deviceData) {
                this.$router.push({ name: 'heatinghistory', params: {id: this.deviceData.uid} });
            }
        },
    },
}
</script>
